import { useContext, useEffect } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import { PeopleList, ProgressRail, StepList } from "../../components/design";
import "./guarantorOnboardingProgress.css";

export default function GuarantorOnboardingProgress({
  step,
  guarantorName,
  originalUser,
  guarantors,
}) {
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    document.body.classList.add("tenant-onboarding-progress-visible");
    return () =>
      document.body.classList.remove("tenant-onboarding-progress-visible");
  }, []);

  const activeName =
    guarantorName || user?.fname || _t("guarantor", "Guarantor");
  const displayGuarantors = guarantors?.length
    ? guarantors
    : [{ name: activeName, status: "active" }];

  // Details(1) Identity(2) Documents(3-5) Financial(6)
  const profileSteps = [
    { id: "details", title: _t("onboardingDetails", "Details") },
    { id: "identity", title: _t("onboardingIdentity", "Identity") },
    { id: "documents", title: _t("onboardingDocuments", "Documents") },
    {
      id: "financial",
      title: _t("onboardingFinancialStudy", "Financial study"),
      badge: _t("onboardingRecommended", "Recommended"),
    },
  ];
  const activeProfileIndex = (() => {
    if (step === 1) return 0;
    if (step === 2) return 1;
    if (step >= 3 && step <= 5) return 2;
    if (step === 6) return 3;
    return 0;
  })();

  const people = [
    {
      key: "you",
      initial: (originalUser?.fname || "Y").charAt(0).toUpperCase(),
      name: _t("you", "You"),
      status: _t("profileCompleted", "Profile completed"),
      complete: true,
    },
    ...displayGuarantors.map((g) => {
      const isActive = g.name === activeName;
      return {
        key: g.name,
        initial: g.name.charAt(0).toUpperCase(),
        name: g.name,
        status: isActive
          ? _t(
              "youAreCompletingTheirProfile",
              "You're completing their profile"
            )
          : g.completed
            ? _t("profileCompleted", "Profile completed")
            : _t("notStarted", "Not started"),
        active: isActive,
        complete: !!g.completed,
      };
    }),
  ];

  return (
    <ProgressRail
      className="guarantor-onboarding-progress"
      label={_t("guarantorProgress", "Guarantor progress")}
      steps={profileSteps}
      activeIndex={activeProfileIndex}
    >
      <p className="onboarding-progress__eyebrow">
        {_t("guarantorProgressEyebrowApplication", "THE APPLICATION")}
      </p>
      <PeopleList people={people} />
      <p className="onboarding-progress__eyebrow">
        {_t("guarantorProfileEyebrow", "{{name}}'S PROFILE", undefined, {
          name: activeName.toUpperCase(),
        })}
      </p>
      <StepList steps={profileSteps} activeIndex={activeProfileIndex} />
    </ProgressRail>
  );
}
